import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription, combineLatest, Subject, of, merge } from 'rxjs';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { LocalStorageKeys } from 'src/app/shared/models/local-storage.model';
import { AuthService } from 'src/app/auth/auth.service';
import { Roles } from 'src/app/shared/models/auth/role.model';
import { map, tap } from 'rxjs/operators';
import { EmployeesService } from 'src/app/shared/services/employees.service';
import { Employee } from 'src/app/shared/models/employee.model';
import { UserService } from 'src/app/shared/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { CostType } from 'src/app/shared/models/cost-types.model';
import { CostService } from 'src/app/shared/services/cost.service';
import { ConfirmService } from 'src/app/shared/services/confirm.service';


@Component({
  selector: 'app-employees',
  templateUrl: './employees.component.html'
})
export class EmployeesComponent implements OnInit, OnDestroy {
  currentUserId: number;
  employees$: Observable<Employee[]>;
  isAdmin: boolean;

  costTypes: CostType[] = [];
  selectedCostTypeId: number = null;
  bulkRegister = false;
  bulkMeritoricalApproval = false;

  get isBulkFormValid(): boolean {
    return !!this.selectedCostTypeId && (this.bulkRegister || this.bulkMeritoricalApproval);
  }

  constructor(
    private employeeService: EmployeeService,
    private toastrService: ToastrService,
    private authService: AuthService,
    private userService: UserService,
    private costService: CostService,
    private confirmService: ConfirmService,
  ) {
  }

  ngOnInit() {
    this.currentUserId = this.userService.getCurrentUserId();
    this.employees$ = merge(
      this.employeeService.employees$,
      this.employeeService.sortedEmployees$,
      this.employeeService.searchedEmployees$
    );
    this.employeeService.changeActiveStatusEmitAction();
    this.isAdmin = this.authService.hasRole(Roles.Admin);

    this.costService.fetchCostTypes().subscribe((types: CostType[]) => this.costTypes = types);
  }

  toggleActiveStatus(isChecked, employee: Employee) {
    const isActive = employee.user.isActive;
    this.employeeService.changeActiveStatusEmitAction();

    this.employeeService.changeActiveStatus(isActive, employee.id).subscribe(_ => {
      this.toastrService.success(`Pomyślnie zmieniono status pracownika na ${isActive ? 'aktywny' : 'nieaktywny'}`);
    },
      _ => employee.user.isActive = !isActive
    );

  }

  onSearch(searachTerm) {
    this.employeeService.searchEmployee(searachTerm);
  }

  onBulkAction(action: 'grant' | 'revoke') {
    if (!this.isBulkFormValid) { return; }

    const costType = this.costTypes.find(ct => ct.id === +this.selectedCostTypeId);
    const permLabels = [
      this.bulkRegister ? 'Rejestracja' : null,
      this.bulkMeritoricalApproval ? 'Akceptacja merytoryczna' : null,
    ].filter(Boolean).join(', ');

    const message = action === 'grant'
      ? `Czy na pewno chcesz nadać uprawnienia (${permLabels}) do typu kosztu "${costType.name}" wszystkim aktywnym pracownikom? Operacja dotyczy wszystkich aktywnych kont w firmie.`
      : `Czy na pewno chcesz odebrać uprawnienia (${permLabels}) do typu kosztu "${costType.name}" wszystkim aktywnym pracownikom? Operacja jest odwracalna, ale wymaga ręcznej korekty per pracownik.`;

    this.confirmService.openConfirmDialog(message, {
      title: action === 'grant' ? 'Nadaj uprawnienia' : 'Odbierz uprawnienia',
      icon: 'warning',
      btnConfirm: action === 'grant' ? 'Nadaj' : 'Odbierz',
      btnDismiss: 'Anuluj',
    }).afterClosed().subscribe(confirmed => {
      if (!confirmed) { return; }
      const permissionTypes = [
        ...(this.bulkRegister ? ['register'] : []),
        ...(this.bulkMeritoricalApproval ? ['meritoricalApproval'] : []),
      ];
      this.employeeService.bulkUpdateCostTypePermissions(+this.selectedCostTypeId, permissionTypes, action)
        .subscribe(
          () => this.toastrService.success(
            action === 'grant'
              ? 'Pomyślnie nadano uprawnienia wszystkim aktywnym pracownikom.'
              : 'Pomyślnie odebrano uprawnienia wszystkim aktywnym pracownikom.'
          ),
          () => this.toastrService.error('Wystąpił błąd podczas aktualizacji uprawnień.')
        );
    });
  }

  ngOnDestroy() {

  }
}
